import DispatcherResource from "./dispatcher.resource";

const dispatcherModule = angular
  .module("app.resources.dispatcher", [])
  .service("Dispatcher", DispatcherResource);

export default dispatcherModule;



// WEBPACK FOOTER //
// ./src/resources/dispatcher/dispatcher.module.js